export const FOOTER_PROPS = {
  itemsPerPageOptions: [5, 10, 25],
  itemsPerPageText: "Einträge pro Seite"
};
